import React, { useEffect, useState } from "react";


export default function SignupBinance(){

    const[email,setEmail] = useState('');
    const[pw,setPw] = useState('');
    const[confirmPw, setConfirmPw] = useState('');
    const[mobile, setMobile] = useState('');
    const[uid, setUid] = useState('');
    const[api, setApi] = useState('');
    const[secretkey, setSecretkey] = useState('');
    const[nickname, setNickname] = useState('');
    const [homeconsent, setHomeconsent] = useState(false);
    const [consent, setConsent] = useState(false);

    const [showMessage, setShowMessage] = useState(false);

    const[emailValid, setEmailValid] = useState(false);
    const[pwValid, setPwValid] = useState(false);
    const[confirmPwValid, setConfirmPwValid] = useState('');
    const[mobileValid, setMobileValid] = useState('');
    const[uidValid, setUidValid] = useState('');
    const[apiValid, setApiValid] = useState('');
    const[secretkeyValid, setSecretkeyValid] = useState('');
    const[nicknameValid, setNicknameValid] = useState('');

    const[notAllow, setNotAllow] = useState(true);

    const [showPassword, setShowPassword] = useState(false); // 비밀번호 보이기 토글 상태
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // 비밀번호 보이기 토글 상태

    useEffect(() => {
      // 여기에 통신 요청이 완료되면 알림 메시지를 자동으로 사라지게 하는 로직을 추가하세요.
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 8000); // 5초 후에 알림 메시지를 숨김
      return () => clearTimeout(timer); // 컴포넌트가 언마운트되면 타이머 해제
    }, [showMessage]); 

    
    const handleEmail = (e) => {
      const newEmail = e.target.value.trim();
      setEmail(newEmail);
      const regex = 
      /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (regex.test(newEmail)) {
          setEmailValid(true);
        } 
      else {
          setEmailValid(false);
        }
      };
    const handlePw = (e) => {
      const newPw = e.target.value.trim();
      setPw(newPw);
        const regex =
          /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
        if (regex.test(newPw)) {
          setPwValid(true);
        } 
      else {
          setPwValid(false);
        }
      };

    const handleConfirmPw = (e) => {
      const newConfirmPw = e.target.value.trim();
      setConfirmPw(newConfirmPw);
      const regex =
        /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
      if (regex.test(newConfirmPw)) {
        setConfirmPwValid(true);
        } 
      else {
          setConfirmPwValid(false);
          }
      };
      
    const handleMobile = (e) => {
      const mobileValue = e.target.value.trim();
      setMobile(mobileValue);
      const regex = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
      if (regex.test(mobileValue)) {
        setMobileValid(true);
      } else {
        setMobileValid(false);
      }
    };
        

    const handleUid = (e) => {
          const newUid = e.target.value.trim();
          setUid(newUid);
          const regex = /^[0-9]{10}$/;
          if (regex.test(newUid)) {
            setUidValid(true);
          } else {
            setUidValid(false);
          }
        };

    
    const handleApi = (e) => {
      const newApi = e.target.value.trim();
      setApi(newApi);
      const regex = /^[a-zA-Z0-9_-]{10,100}$/;
      if (regex.test(newApi)) {
        setApiValid(true);
      } else {
        setApiValid(false);
      }
    };

    const handleSecretkey = (e) => {
      const newSecretkey = e.target.value.trim();
      setSecretkey(newSecretkey);
      const regex = /^[a-zA-Z0-9]{10,100}$/;
      if (regex.test(newSecretkey)) {
        setSecretkeyValid(true);
      } else {
        setSecretkeyValid(false);
      }
    };


    const handleNickname = (e) => {
      const newNickname = e.target.value.trim();
      setNickname(newNickname);
      const regex =
      /^[ㄱ-ㅎ가-힣a-zA-Z0-9]{2,16}$/;
      if (regex.test(newNickname)) {
        setNicknameValid(true);
      } else {
        setNicknameValid(false);
      }
    };

    const handleHomeconsent = () => setHomeconsent(!homeconsent);
    const handleConsent = () => setConsent(!consent);
    
    useEffect(() => {
        if(emailValid && pwValid && confirmPwValid && mobileValid && uidValid && apiValid && secretkeyValid && nicknameValid && homeconsent && consent) {
          setNotAllow(false);
          return;
        }
        setNotAllow(true);
      }, [emailValid, pwValid, confirmPwValid, mobileValid, uidValid, apiValid, secretkeyValid, nicknameValid, homeconsent, consent]);
    
    
    const onClickSaveFile = () => {

      setShowMessage(true);

      fetch('/signup/members_binance', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email,
                pw,
                mobile,
                uid,
                api,
                secretkey,
                nickname,
            }),
        })

        //에러 메시지 받아오는건 다음에 다시 하자!

        .then(response => {
          if (!response.ok) {
            return response.text().then(errorMessage => {
              // 서버로부터 에러 응답을 받은 경우
              throw new Error(errorMessage);
            });
          }
          return response.json();
        })
        .then(result => {
            // const result = JSON.parse(message)
            // 서버로부터 받은 데이터를 처리
            setShowMessage(true);
            alert(result.message);
            // 로그인 성공 후 리다이렉트할 URL
            if (result.ok === true){
              const redirectUrl = `/LoginAtsBinance`;
                // 페이지를 리다이렉트
              window.location.href = redirectUrl;
            };
        })
        .catch(error => {
            // 서버 오류 또는 요청이 실패한 경우
            console.error('오류 발생:', error);
            alert(error);
        });
      
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSaveFile();
    }
  };

    return(
      <div className="auth-page auth-page--binance">
        <span className="auth-page__overlay" />
        <div className="auth-page__content auth-page__content--wide">
          <section className="auth-hero">
            <p className="auth-badge">Binance Suite</p>
            <h1>
              Binance 계정을<br />
              안전하게 연동하세요.
            </h1>
            <p className="auth-hero__subtitle">
              변동성이 큰 알트 시장에서도 안정적으로 운용할 수 있도록, Binance 전용 API와 UID 정보를 한 화면에서 관리합니다.
            </p>
            <ul className="auth-highlight-list">
              <li>멀티 심볼 진입/대기 리스트 연동</li>
              <li>슬리피지·리스크 옵션 한 번에 저장</li>
              <li>모바일·데스크톱 동시 제어 지원</li>
            </ul>
            <div className="auth-hero__stats">
              <article>
                <span>연동 소요</span>
                <strong>약 2분</strong>
              </article>
              <article>
                <span>필수 입력</span>
                <strong>7개 항목</strong>
              </article>
              <article>
                <span>지원 전략</span>
                <strong>20+ SET</strong>
              </article>
            </div>
          </section>

          <section className="auth-card auth-card--large">
            <div className="auth-card__header">
              <h2>Binance 회원가입</h2>
              <p>UID · API 키는 암호화되어 저장되며 필요 시 언제든지 갱신할 수 있습니다.</p>
            </div>

            {showMessage && (
              <div className="auth-inline-message">
                Binance API 상태를 확인 중입니다. 잠시만 기다려 주세요!
              </div>
            )}

            <div className="auth-form auth-form--grid">
              <div className="auth-field auth-field--full">
                <label>E-mail address</label>
                <div className="auth-input">
                  <input 
                    type='text'
                    placeholder="test@gmail.com"
                    value={email}
                    onChange={handleEmail}
                    onKeyDown={handleKeyDown} />
                </div>
                {!emailValid && email.length > 0 && (
                  <p className="auth-error">Please enter a valid email format.</p>
                )}
              </div>

              <div className="auth-field">
                <label>Password</label>
                <div className="auth-input auth-input--with-action">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="At least 8 characters incl. letters, numbers, symbols"
                    value={pw}
                    onChange={handlePw}
                    onKeyDown={handleKeyDown}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="auth-toggle"
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
                {!pwValid && pw.length > 0 && (
                  <p className="auth-error">Please enter at least 8 characters including letters, numbers, symbols.</p>
                )}
              </div>

              <div className="auth-field">
                <label>Confirm password</label>
                <div className="auth-input auth-input--with-action">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Re-enter the same password"
                    value={confirmPw}
                    onChange={handleConfirmPw}
                    onKeyDown={handleKeyDown}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="auth-toggle"
                  >
                    {showConfirmPassword ? "Hide" : "Show"}
                  </button>
                </div>
                {!confirmPwValid && confirmPw.length > 0 && (
                  <p className="auth-error">Please enter the same password in a valid format.</p>
                )}
              </div>

              <div className="auth-field">
                <label>Mobile Number</label>
                <div className="auth-input">
                  <input 
                    type='text'
                    placeholder="Please enter only numbers without '-'"
                    value={mobile}
                    onChange={handleMobile}
                    onKeyDown={handleKeyDown} />
                </div>
                {!mobileValid && mobile.length > 0 && (
                  <p className="auth-error">Please enter only numbers without '-'</p>
                )}
              </div>

              <div className="auth-field">
                <label>UID</label>
                <div className="auth-input">
                  <input 
                    type='text'
                    placeholder="Enter only 10 digits."
                    value={uid}
                    onChange={handleUid}
                    onKeyDown={handleKeyDown} />
                </div>
                {!uidValid && uid.length > 0 && (
                  <p className="auth-error">Please enter only 10 digits.</p>
                )}
              </div>

              <div className="auth-field">
                <label>API</label>
                <div className="auth-input">
                  <input 
                    type='text'
                    placeholder="Please enter the API value exactly (copy & paste)"
                    value={api}
                    onChange={handleApi}
                    onKeyDown={handleKeyDown} />
                </div>
                {!apiValid && api.length > 0 && (
                  <p className="auth-error">Please enter correct API inputs.</p>
                )}
              </div>

              <div className="auth-field">
                <label>SecretKey</label>
                <div className="auth-input">
                  <input 
                    type='text'
                    placeholder="Please enter the SecretKey exactly (copy & paste)"
                    value={secretkey}
                    onChange={handleSecretkey}
                    onKeyDown={handleKeyDown} />
                </div>
                {!secretkeyValid && secretkey.length > 0 && (
                  <p className="auth-error">Please enter correct SecretKey inputs.</p>
                )}
              </div>

              <div className="auth-field">
                <label>Nickname</label>
                <div className="auth-input">
                  <input 
                    type='text'
                    placeholder="Enter at least 2 and no more than 16 characters."
                    value={nickname}
                    onChange={handleNickname}
                    onKeyDown={handleKeyDown} />
                </div>
                {!nicknameValid && nickname.length > 0 && (
                  <p className="auth-error">Please enter a valid nickname.</p>
                )}
              </div>
            </div>

            <div className="auth-checkbox-group">
              <label className="auth-checkbox">
                <input 
                  type="checkbox"
                  checked={homeconsent}
                  onChange={handleHomeconsent}
                />
                <span>
                  Binance auto trade system 사이트 이용약관에 동의합니다{' '}
                  <a href="/HomeTerms" target="_blank" rel="noopener noreferrer">(내용확인)</a>
                </span>
              </label>
              <label className="auth-checkbox">
                <input 
                  type="checkbox"
                  checked={consent}
                  onChange={handleConsent}
                />
                <span>
                  개인정보 수집/이용에 동의합니다{' '}
                  <a href="/PrivacyTerms" target="_blank" rel="noopener noreferrer">(내용확인)</a>
                </span>
              </label>
            </div>

            <button
              onClick={() => onClickSaveFile()}
              disabled={notAllow}
              className="auth-submit"
            >
              Sign up
            </button>

            <div className="auth-links">
              <a href="/SelectBinance">바이낸스 전략 메인 페이지</a>
              <span>·</span>
              <a href="/LoginAtsBinance">로그인 페이지</a>
            </div>
          </section>
        </div>
      </div>
    );
}